import { IndexType } from '../seo/constants'
import { isNonEmptyArray } from '@/utils/checks'
import {
  isFacetPageType,
  isLocationPageType,
  isTaxonomyPageType
} from './pageTypeCheck'
import { isNil, isObject } from '../../utils/checks'
import { Center } from '@/types/models/Center.model'
import { Location } from '../../types/models/Location.model'
import { Term } from '@/types/models/Term.model'
import { getIndexTypeForLocation } from '../location/useCases/getIndexTypeForLocation'
import { getIndexTypeForTerm } from '../term/useCases/getIndexTypeForTerm'
import { PageType } from '@/types/models/PageType.model'

type ShouldIndexPage = (
  term: Term | null,
  location: Location | null,
  results: Center[],
  pageType: PageType
) => boolean

export const shouldIndexPage: ShouldIndexPage = (
  term,
  location,
  results,
  pageType
): boolean => {
  let currentIndexType = IndexType.FULL_INDEX

  if (isObject(location)) {
    currentIndexType = getIndexTypeForLocation(location)
  }

  if (isObject(term)) {
    currentIndexType = getIndexTypeForTerm(term)
  }

  if (!isNonEmptyArray(results)) return false

  if (isLocationPageType(pageType)) return true

  if (isNil(term?.indexType)) return true

  if (currentIndexType === IndexType.NO_INDEX) return false

  if (currentIndexType === IndexType.NO_FACET) {
    return !isFacetPageType(pageType)
  }

  if (currentIndexType === IndexType.NO_CITY_FACET) {
    return !(location?.type === 'City' && isFacetPageType(pageType))
  }

  if (currentIndexType === IndexType.REGION_FACET_ONLY) {
    return (
      (location?.type === 'Region' && isFacetPageType(pageType)) ||
      isTaxonomyPageType(pageType)
    )
  }

  if (currentIndexType === IndexType.COUNTRY_FACET_ONLY) {
    return (
      (location?.type === 'Country' && isFacetPageType(pageType)) ||
      isTaxonomyPageType(pageType)
    )
  }

  return true
}
